/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import { resellerApi } from '@api/baseApi'
import LoginForm from '@components/LoginForm'
import { rules, schema } from '@config/yup.schema'
import { yupResolver } from '@hookform/resolvers/yup'
import {
  Dialog, DialogContent, DialogTitle, IconButton,
} from '@material-ui/core'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import CloseIcon from '@material-ui/icons/Close'
import getDomain from '@config/domain'

const LoginDialog = ({
  setAvailableAccountData,
  setFormValue,
  setIsUseExistingAcc,
  ...props
}) => {
  const methods = useForm({
    resolver: yupResolver(schema({
      username: rules.email,
      password: rules.password,
    })),
  })

  const [isSubmitting, setSubmitting] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  const onSubmit = async (value) => {
    const params = {
      ...value,
      scope: 'reseller',
      grant_type: 'password',
      assign_domain: getDomain(),
    }

    try {
      setSubmitting(true)
      const { status, data } = await resellerApi.post('/oauth/token', params)
      if (status === 200) {
        setSubmitting(false)
        const payload = data?.data
        setFormValue('email', payload.email, { shouldValidate: true })
        setFormValue('name', payload.name, { shouldValidate: true })
        setFormValue('address', payload.address, { shouldValidate: true })
        setFormValue('phone', payload.phone_number, { shouldValidate: true })
        setFormValue('district', payload?.district, { shouldValidate: true })
        setFormValue('provider', 'available_account', { shouldValidate: true })
        setAvailableAccountData(data)
        setIsUseExistingAcc(true)
        props.onClose()
      }
    } catch (error) {
      setSubmitting(false)
      enqueueSnackbar(
        error.response?.data?.error,
        { variant: 'error' },
      )
    }
  }

  return (
    <Dialog
      {...props}
    >
      <DialogTitle style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton onClick={props.onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <LoginForm
            onSubmit={onSubmit}
            isSubmitting={isSubmitting}
            disableRegisterButton
          />
        </FormProvider>
      </DialogContent>
    </Dialog>
  )
}
export default LoginDialog
